import { ViewModel } from '../view-model';
export class EventUsers implements ViewModel {
  friendlyTypeNameSingular: string = 'Event Users';
  apiRoute: string;

  eventId: string;
  userId: string;
  username: string;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.eventId = data.eventId;
    this.userId = data.userId;
    this.username = data.username;
  }
}
